"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PRODUCTS = void 0;

var deepFreeze = require('deep-freeze');
/*
 * name:  used everywhere for display
 * shortName: used for css classes and maybe some other places
 * searchKey: used for elastic search
 * id: used everywhere
 */


var PRODUCTS = {
  ABS: {
    name: 'abs',
    id: '256'
  },
  ANALYTICS: {
    name: 'analytics',
    id: '4096'
  },
  DEBTWIRE: {
    name: 'debtwire',
    id: '8'
  },
  MUNICIPALS: {
    name: 'municipals',
    id: '512'
  },
  PRIMARY_ISSUANCE: {
    name: 'primaryissuance',
    id: '32'
  },
  XTRACT: {
    name: 'xtract',
    id: '128'
  }
};
exports.PRODUCTS = PRODUCTS;
var EDITIONS_MAP = deepFreeze({
  EUROPE: {
    name: 'Europe',
    filterName: 'Europe',
    shortName: 'eu',
    searchKey: 'eu',
    editionKey: 'eu',
    id: "".concat(PRODUCTS.DEBTWIRE.id, "_1"),
    fullId: "".concat(PRODUCTS.DEBTWIRE.id, "_1")
  },
  NORTH_AMERICA: {
    name: 'North America',
    filterName: 'North America',
    shortName: 'na',
    searchKey: 'na',
    editionKey: 'na',
    id: "".concat(PRODUCTS.DEBTWIRE.id, "_2"),
    fullId: "".concat(PRODUCTS.DEBTWIRE.id, "_2")
  },
  LATIN_AMERICA: {
    name: 'Latin America',
    filterName: 'Latin America',
    shortName: 'latam',
    searchKey: 'la',
    editionKey: 'la',
    id: "".concat(PRODUCTS.DEBTWIRE.id, "_4"),
    fullId: "".concat(PRODUCTS.DEBTWIRE.id, "_4")
  },
  ASIA_PACIFIC: {
    name: 'Asia-Pacific',
    filterName: 'Asia-Pacific',
    shortName: 'apac',
    searchKey: 'ap',
    editionKey: 'ap',
    id: "".concat(PRODUCTS.DEBTWIRE.id, "_8"),
    fullId: "".concat(PRODUCTS.DEBTWIRE.id, "_8")
  },
  CEEMEA: {
    name: 'CEEMEA',
    filterName: 'CEEMEA',
    shortName: 'ceemea',
    searchKey: 'ce',
    editionKey: 'ce',
    id: "".concat(PRODUCTS.DEBTWIRE.id, "_64"),
    fullId: "".concat(PRODUCTS.DEBTWIRE.id, "_64")
  },
  MIDDLE_MARKET: {
    name: 'Middle Market',
    filterName: 'North America Middle Market',
    shortName: 'mm',
    searchKey: 'mm',
    editionKey: 'mm',
    id: "".concat(PRODUCTS.DEBTWIRE.id, "_131072"),
    fullId: "".concat(PRODUCTS.DEBTWIRE.id, "_2_").concat(PRODUCTS.DEBTWIRE.id, "_131072")
  },
  MIDDLE_MARKET_EUROPE: {
    name: 'Middle Market',
    filterName: 'Europe Middle Market',
    shortName: 'mmeu',
    searchKey: 'mmeu',
    editionKey: 'mmeu',
    id: "".concat(PRODUCTS.DEBTWIRE.id, "_8388608"),
    fullId: "".concat(PRODUCTS.DEBTWIRE.id, "_1_").concat(PRODUCTS.DEBTWIRE.id, "_8388608")
  },
  LITIGATION_FINANCE: {
    name: 'Litigation Finance',
    filterName: 'Litigation Finance',
    shortName: 'litfin',
    searchKey: 'lf',
    editionKey: 'lf',
    id: "".concat(PRODUCTS.DEBTWIRE.id, "_33554432"),
    fullId: "".concat(PRODUCTS.DEBTWIRE.id, "_33554432")
  },
  XTRACT_EUROPE: {
    name: 'Xtract Research',
    filterName: 'Europe',
    shortName: 'xna',
    searchKey: 'eu',
    editionKey: 'eu',
    id: "".concat(PRODUCTS.XTRACT.id, "_1"),
    fullId: "".concat(PRODUCTS.XTRACT.id, "_1")
  },
  XTRACT_NORTH_AMERICA: {
    name: 'Xtract Research',
    filterName: 'North America',
    shortName: 'xeu',
    searchKey: 'na',
    editionKey: 'na',
    id: "".concat(PRODUCTS.XTRACT.id, "_2"),
    fullId: "".concat(PRODUCTS.XTRACT.id, "_2")
  },
  XTRACT_ASIA_PACIFIC: {
    name: 'Xtract Research',
    filterName: 'Asia-Pacific',
    shortName: 'xapac',
    searchKey: 'ap',
    editionKey: 'ap',
    id: "".concat(PRODUCTS.XTRACT.id, "_8"),
    fullId: "".concat(PRODUCTS.XTRACT.id, "_8")
  },
  PRIMARY_ISSUANCE_EUROPE: {
    name: 'Primary ID',
    filterName: 'Par Europe',
    searchKey: 'pi',
    editionKey: 'pi',
    subEditionKey: 'pi-eu',
    id: "".concat(PRODUCTS.PRIMARY_ISSUANCE.id, "_1"),
    fullId: "".concat(PRODUCTS.PRIMARY_ISSUANCE.id, "_1")
  },
  PRIMARY_ISSUANCE_NORTH_AMERICA: {
    name: 'Primary ID',
    filterName: 'Par North America',
    searchKey: 'pi',
    editionKey: 'pi',
    subEditionKey: 'pi-na',
    id: "".concat(PRODUCTS.PRIMARY_ISSUANCE.id, "_2"),
    fullId: "".concat(PRODUCTS.PRIMARY_ISSUANCE.id, "_2")
  },
  PRIMARY_ISSUANCE_ASIA_PACIFIC: {
    name: 'Primary ID',
    filterName: 'Par Asia-Pacific',
    searchKey: 'pi',
    editionKey: 'pi',
    subEditionKey: 'pi-ap',
    id: "".concat(PRODUCTS.PRIMARY_ISSUANCE.id, "_8"),
    fullId: "".concat(PRODUCTS.PRIMARY_ISSUANCE.id, "_8")
  },
  PRIMARY_ISSUANCE_LATIN_AMERICA: {
    name: 'Primary ID',
    filterName: 'Par Latin America',
    searchKey: 'pi',
    editionKey: 'pi',
    subEditionKey: 'pi-la',
    id: "".concat(PRODUCTS.PRIMARY_ISSUANCE.id, "_4"),
    fullId: "".concat(PRODUCTS.PRIMARY_ISSUANCE.id, "_4")
  },
  PRIMARY_ISSUANCE_EEMEA: {
    name: 'Primary ID',
    filterName: 'Par CEEMEA',
    searchKey: 'pi',
    editionKey: 'pi',
    subEditionKey: 'pi-ce',
    id: "".concat(PRODUCTS.PRIMARY_ISSUANCE.id, "_64"),
    fullId: "".concat(PRODUCTS.PRIMARY_ISSUANCE.id, "_64")
  },
  PRIMARY_ISSUANCE_MIDDLE_MARKET: {
    name: 'Primary ID',
    filterName: 'Par North America Middle Market',
    searchKey: 'pi',
    editionKey: 'pi',
    subEditionKey: 'pi-mm',
    id: "".concat(PRODUCTS.PRIMARY_ISSUANCE.id, "_131072"),
    fullId: "".concat(PRODUCTS.PRIMARY_ISSUANCE.id, "_131072")
  },
  PRIMARY_ISSUANCE_MIDDLE_MARKET_EUROPE: {
    name: 'Primary ID',
    filterName: 'Par Europe Middle Market',
    searchKey: 'pi',
    editionKey: 'pi',
    subEditionKey: 'pi-mmeu',
    id: "".concat(PRODUCTS.PRIMARY_ISSUANCE.id, "_8388608"),
    fullId: "".concat(PRODUCTS.PRIMARY_ISSUANCE.id, "_8388608")
  },
  ABS_EUROPE: {
    name: 'ABS',
    filterName: 'ABS',
    shortName: 'abseu',
    searchKey: 'ab',
    editionKey: 'ab',
    id: "".concat(PRODUCTS.ABS.id, "_1"),
    fullId: "".concat(PRODUCTS.ABS.id, "_1")
  },
  ABS_NORTH_AMERICA: {
    name: 'ABS',
    filterName: 'ABS',
    shortName: 'absna',
    searchKey: 'ab',
    editionKey: 'ab',
    id: "".concat(PRODUCTS.ABS.id, "_2"),
    fullId: "".concat(PRODUCTS.ABS.id, "_2")
  },
  MUNICIPALS: {
    name: 'Municipals',
    filterName: 'Municipals',
    shortName: 'muni',
    searchKey: 'mu',
    editionKey: 'mu',
    id: "".concat(PRODUCTS.MUNICIPALS.id, "_2"),
    fullId: "".concat(PRODUCTS.MUNICIPALS.id, "_2")
  },
  ANALYTICS_EUROPE: {
    name: 'Analytics Europe',
    shortName: 'aneu',
    id: "".concat(PRODUCTS.ANALYTICS.id, "_1"),
    fullId: "".concat(PRODUCTS.ANALYTICS.id, "_1")
  },
  ANALYTICS_NORTH_AMERICA: {
    name: 'Analytics North America',
    shortName: 'anna',
    id: "".concat(PRODUCTS.ANALYTICS.id, "_2"),
    fullId: "".concat(PRODUCTS.ANALYTICS.id, "_2")
  },
  ANALYTICS_ASIA_PACIFIC: {
    name: 'Analytics Asia-Pacific',
    shortName: 'anapac',
    id: "".concat(PRODUCTS.ANALYTICS.id, "_8"),
    fullId: "".concat(PRODUCTS.ANALYTICS.id, "_8")
  }
});
var _default = EDITIONS_MAP;
exports["default"] = _default;